export const showTagsEditorReadBadges = (vm: {
  loading?: boolean;
  isTagsEmpty?: boolean;
  editMode?: boolean;
  editOnly?: boolean;
}) => !vm.loading && !vm.isTagsEmpty && !vm.editMode && !vm.editOnly;

export const showTagsEditorEditButton = (vm: {
  loading?: boolean;
  editMode?: boolean;
  readOnly?: boolean;
  editOnly?: boolean;
}) => (!vm.loading || Boolean(vm.editMode)) && !vm.readOnly && !vm.editOnly;
